import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const Tab = lazyImport(() => import('@mui/material/Tab'), <div />)